module.exports = __webpack_public_path__ + "static/media/arts_22.ea9c9e3a.jpg";